import { useId } from "react";
import { startOfDay } from "date-fns";
import { Box } from "@mui/material";
import { ByzMuiDatePicker } from "src/components/core-components/mui/inputs/ByzMuiDatePicker";

export type InlineDateSelectProps = {
  value: Date;
  onChange: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
};

/** Same date chip + popover pattern as patient-table GeneralInfo. */
export default function InlineDateSelect({
  value,
  onChange,
  minDate,
  maxDate,
}: Readonly<InlineDateSelectProps>) {
  const inputId = useId();

  return (
    <Box
      sx={{
        minWidth: "200px",
        flexShrink: 0,
        "& .MuiFormControl-root": {
          minWidth: "200px",
        },
      }}
    >
      <ByzMuiDatePicker
        value={value}
        minDate={minDate}
        maxDate={maxDate}
        format="dd MMMM yyyy"
        onChange={(v) => {
          const next = v ? new Date(v as Date) : new Date();
          onChange(startOfDay(next));
        }}
        slotProps={{
          textField: {
            id: inputId,
            label: "",
            placeholder: "GG AA YYYY",
            sx: {
              "& .MuiOutlinedInput-root": {
                height: "44px",
                borderRadius: "8px",
                backgroundColor: "#fff",
                fontFamily: "Poppins",
                pr: "4px",
              },
              "& .MuiOutlinedInput-input": {
                py: "10px",
                px: "12px",
                color: "#111721",
                fontSize: "13px",
                fontFamily: "Poppins",
                fontWeight: 400,
                lineHeight: "22px",
                cursor: "text",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#98A2B3",
                opacity: 1,
              },
              "& .MuiIconButton-root": {
                mr: "2px",
              },
            },
          },
          openPickerButton: {
            sx: {
              color: "#39455B",
            },
          },
        }}
      />
    </Box>
  );
}
